import type { GeneralConfig } from '@shared/types/Config';

export const inventoryQueueViewConfig: GeneralConfig = {
    sortFieldMap: {},
};
